import React, { useEffect } from "react"
import { useLocation, useMatch, useNavigate } from "react-router-dom"

import { useAppDispatch } from "redux/hooks"
import { openDialog } from "redux/features/dialog/dialogSlice"
import {
  CONSENT_MATCH,
  REFINANCE_CONSENT_MODAL,
  PAYMENT_FAILURE_MODAL,
  PAYMENT_SUCCESS_MODAL,
  PAYMENT_SUCCESS_MATCH,
  PAYMENT_FAILURE_MATCH,
  PAYMENT_SCHEDULE_CREATE_MODAL,
  PAYMENT_SCHEDULE_VIEW_MODAL,
  PAYMENT_SCHEDULE_SIGN_MODAL,
  PAYMENT_SCHEDULE_PROMISE_MODAL,
  PAYMENT_SCHEDULE_CREATE_MODAL_MATCH,
  PAYMENT_SCHEDULE_VIEW_MODAL_MATCH,
  PAYMENT_SCHEDULE_SIGN_MODAL_MATCH,
  PAYMENT_SCHEDULE_PROMISE_MODAL_MATCH,
  PAYMENT_SCHEDULE_FALLBACK_MATCH,
  ISSUE_CREATE_MODAL_MATCH,
  ISSUE_CREATE_MODAL,
  HELP_HOW_MATCH,
  HELP_HOW_MODAL,
  HELP_WHY_MATCH,
  HELP_WHY_MODAL,
  HELP_WHEREFORE_MATCH,
  HELP_WHEREFORE_MODAL,
  HELP_WHAT_MATCH,
  HELP_WHAT_MODAL,
} from "config"
import Debts from "components/Debts/List"
// import Welcome from "components/Debts/Welcome"
import Redirect from "components/Debts/Redirect"
// import RefinanceBanner from "components/Refinance/Banner"
import { Content } from "pages/dashboard/elements"

const ClaimsPage = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  const consentMatch = useMatch(CONSENT_MATCH)

  const paymentSuccessMatch = useMatch(PAYMENT_SUCCESS_MATCH)
  const paymentFailureMatch = useMatch(PAYMENT_FAILURE_MATCH)
  const paymentScheduleCreateMatch = useMatch(
    PAYMENT_SCHEDULE_CREATE_MODAL_MATCH,
  )
  const paymentScheduleViewMatch = useMatch(PAYMENT_SCHEDULE_VIEW_MODAL_MATCH)
  const paymentScheduleSignMatch = useMatch(PAYMENT_SCHEDULE_SIGN_MODAL_MATCH)
  const paymentSchedulePromiseMatch = useMatch(
    PAYMENT_SCHEDULE_PROMISE_MODAL_MATCH,
  )
  const paymentScheduleFallbackMatch = useMatch(PAYMENT_SCHEDULE_FALLBACK_MATCH)

  const issueCreateMatch = useMatch(ISSUE_CREATE_MODAL_MATCH)

  const helpHowMatch = useMatch(HELP_HOW_MATCH)
  const helpWhyMatch = useMatch(HELP_WHY_MATCH)
  const helpWhereforeMath = useMatch(HELP_WHEREFORE_MATCH)
  const helpWhatMath = useMatch(HELP_WHAT_MATCH)

  const openPaymentModal = (type: string) => {
    dispatch(openDialog({ type: type }))
  }

  const openConsentModal = () => {
    dispatch(
      openDialog({
        type: REFINANCE_CONSENT_MODAL,
        content: {
          consentId: consentMatch?.params["id"],
        },
      }),
    )
  }

  const openPaymentScheduleCreateModal = () => {
    dispatch(
      openDialog({
        type: PAYMENT_SCHEDULE_CREATE_MODAL,
        content: {
          debtId: paymentScheduleViewMatch?.params["debt_id"],
          paymentScheduleId: "0", // TODO: fix fallback
        },
      }),
    )
  }

  const openPaymentScheduleViewModal = () => {
    dispatch(
      openDialog({
        type: PAYMENT_SCHEDULE_VIEW_MODAL,
        content: {
          debtId: paymentScheduleViewMatch?.params["debt_id"],
          paymentScheduleId: paymentScheduleViewMatch?.params["id"],
        },
      }),
    )
  }

  const openPaymentScheduleSignModal = () => {
    dispatch(
      openDialog({
        type: PAYMENT_SCHEDULE_SIGN_MODAL,
        content: {
          debtId: paymentScheduleSignMatch?.params["debt_id"],
          paymentScheduleId: paymentScheduleSignMatch?.params["id"],
        },
      }),
    )
  }

  const openPaymentSchedulePromiseModal = () => {
    dispatch(
      openDialog({
        type: PAYMENT_SCHEDULE_PROMISE_MODAL,
        content: {
          debtId: paymentSchedulePromiseMatch?.params["debt_id"],
          paymentScheduleId: paymentSchedulePromiseMatch?.params["id"],
        },
      }),
    )
  }

  const openIssueCreateModal = () => {
    dispatch(
      openDialog({
        type: ISSUE_CREATE_MODAL,
        content: {
          debtId: issueCreateMatch?.params["debt_id"],
        },
      }),
    )
  }

  const openHelpModal = (type: string) => {
    dispatch(
      openDialog({
        type: type,
        content: {},
      }),
    )
  }

  useEffect(() => {
    if (paymentSuccessMatch) {
      openPaymentModal(PAYMENT_SUCCESS_MODAL)
    } else if (paymentFailureMatch) {
      openPaymentModal(PAYMENT_FAILURE_MODAL)
    } else if (consentMatch) {
      openConsentModal()
    } else if (paymentScheduleCreateMatch) {
      openPaymentScheduleCreateModal()
    } else if (paymentScheduleViewMatch) {
      openPaymentScheduleViewModal()
    } else if (paymentScheduleSignMatch) {
      openPaymentScheduleSignModal()
    } else if (paymentSchedulePromiseMatch) {
      openPaymentSchedulePromiseModal()
    } else if (issueCreateMatch) {
      openIssueCreateModal()
    } else if (helpHowMatch) {
      openHelpModal(HELP_HOW_MODAL)
    } else if (helpWhyMatch) {
      openHelpModal(HELP_WHY_MODAL)
    } else if (helpWhereforeMath) {
      openHelpModal(HELP_WHEREFORE_MODAL)
    } else if (helpWhatMath) {
      openHelpModal(HELP_WHAT_MODAL)
    } else if (paymentScheduleFallbackMatch) {
      navigate("/")
    }
  }, [location])

  return (
    <Content data-testid="claims-page">
      <Redirect />
      {/*
        // TODO: use settings to show/hide components
        <RefinanceBanner />
        <Welcome />
      */}
      <Debts />
    </Content>
  )
}

export default ClaimsPage
